import React from 'react';
import LinkModel from '../../Types/LinkModel';
import BrandPageModel from '../../Types/BrandPageModel';
import Button from '../../Components/Button';
import { StyledBrandsSection } from './Styles/Brands-block.styling';

interface BrandsBlockProps {
    title: string;
    linkText: string;
    pages: BrandPageModel[];
    url: LinkModel;
}

const BrandsBlock = (props: BrandsBlockProps) => {
    const { title, linkText, pages, url } = props;

    return (
        <StyledBrandsSection className="brand-block section">
            <div className="brand-block__header">
                {title && title != "" &&
                    <h2 className="brand-block__title">{title}</h2>
                }
                {url?.href && url.href != "" &&
                    <Button
                        btnSize="medium"
                        btnType="outlined"
                        onClick={() => window.location.href = url.href}
                        className="additional__btn"
                    >
                        {linkText}
                    </Button>
                }
            </div>
            <ul className="brand-block__list grid">
                {pages.map((page, idx) => (
                    <li className="brand-block__list--item" key={page.text + idx}>
                        <a href={page.href} className="brand-block__link">
                            {!page.imageUrl || page.imageUrl == ""
                                ? <p className="brand-block__text">{page.text}</p>
                                : <img className="brand-block__image" src={page.imageUrl} alt={page.imageAlt} />}
                        </a>
                    </li>
                ))}
            </ul>
        </StyledBrandsSection>
    );
};

export default BrandsBlock;
